// import external dependencies
import 'jquery';

import 'owl.carousel';
import 'isotope-layout/dist/isotope.pkgd.min';
import 'jquery-sticky';


// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import portfolio from './routes/portfolio';
import partners from './routes/partners';
import ethos from './routes/ethos';
import heritage from './routes/heritage';
//import test from './routes/test';
import singleTmProduct from './routes/singleproduct';
import filters from './routes/filters';
import blog from './routes/blog';
import project from './routes/project';
import singlePost from './routes/singlepost';
import singleProject from './routes/singleproject';
import contact from './routes/contact';
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  portfolio,

  partners,

  ethos,

  heritage,

  filters,

  blog,
  
  singlePost,

  project,
  
  singleProject,

  contact,

  //test,

  singleTmProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faTwitter, faInstagram, faLinkedinIn, faVimeoV } from '@fortawesome/free-brands-svg-icons';

// add the imported icons to the library
library.add(faFacebook, faTwitter, faInstagram , faLinkedinIn, faVimeoV);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();




// WEBPACK FOOTER //
// ./scripts/main.js